import { render, staticRenderFns } from "./optimizerx.vue?vue&type=template&id=2e15c735&scoped=true&v-once=true"
import script from "./optimizerx.vue?vue&type=script&lang=js"
export * from "./optimizerx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15c735",
  null
  
)

export default component.exports